import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["status", "id", "title", "isClosable", "onClose", "content", "onClick", "position", "action"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import toaster from 'toasted-notes';
import { StyledToast } from './Toast.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ToastSlice = function ToastSlice(_ref) {
  var status = _ref.status,
      id = _ref.id,
      title = _ref.title,
      isClosable = _ref.isClosable,
      onClose = _ref.onClose,
      content = _ref.content,
      onClick = _ref.onClick,
      position = _ref.position,
      action = _ref.action,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(StyledToast, _objectSpread(_objectSpread({
    id: id,
    title: title,
    status: status,
    isToast: true,
    onDismiss: isClosable && onClose,
    onClick: onClick,
    action: action,
    "data-position": position
  }, rest), {}, {
    children: content
  }));
};

function Toast() {
  function notify(_ref2) {
    var _ref2$position = _ref2.position,
        position = _ref2$position === void 0 ? 'top-right' : _ref2$position,
        _ref2$duration = _ref2.duration,
        duration = _ref2$duration === void 0 ? 5000 : _ref2$duration,
        render = _ref2.render,
        title = _ref2.title,
        content = _ref2.content,
        status = _ref2.status,
        onClick = _ref2.onClick,
        action = _ref2.action,
        _ref2$isClosable = _ref2.isClosable,
        isClosable = _ref2$isClosable === void 0 ? true : _ref2$isClosable;
    var options = {
      position: position,
      duration: duration
    };

    if (render) {
      return toaster.notify(function (_ref3) {
        var onClose = _ref3.onClose,
            id = _ref3.id;
        return _jsx(_Fragment, {
          children: render({
            onClose: onClose,
            id: id
          })
        });
      }, options);
    }

    toaster.notify(function (_ref4) {
      var onClose = _ref4.onClose,
          id = _ref4.id;
      return _jsx(ToastSlice, {
        onClose: onClose,
        id: id,
        title: title,
        content: content,
        status: status,
        isClosable: isClosable,
        onClick: onClick,
        position: position,
        action: action
      });
    }, options);
  }

  return notify;
}

export default Toast;